<template>
  <v-container>
      <p style="font-size:2rem;"><b> URL DEL EN VIVO:</b> </p>
    <v-text-field   class="field centered_input" color="black" background-color="white" v-model="newUrl"> </v-text-field>
    <v-btn color="rgba(255,255,255,.5)" style="font-size:1.2rem;" @click="changeeUrl">Ingresar URL </v-btn> <br><br>
    <v-btn v-if="!live" color="rgba(51,204,255,.7)" style="font-size:1.2rem;" @click="activateLive">Activar En Vivo</v-btn>
    <v-btn v-else color="rgba(255,60,51,.7)" style="font-size:1.2rem;" @click="desactivateLive">Desactivar En Vivo</v-btn>
  </v-container>
</template>
<script>
import { db } from "@/main";
export default {
  data() {
    return {
      newUrl: "",
      live: null
    };
  },
  methods: {
    changeeUrl: async function () {
      if ("" == this.newUrl) {
        alert("No estas ingresando una url");
      } else {
        await db.collection("stream").doc("url").update({ url_video: this.newUrl });
      }
      this.newUrl = ""
    },
    activateLive: async function () {
       await db.collection("stream").doc("url").update({ enabled: true }); 
       this.live = true;
    },
    desactivateLive: async function () {
       await db.collection("stream").doc("url").update({ enabled: false }); 
      
       this.live = false;
    }
  },
  created(){
    db.collection("stream")
      .doc("url")
      .get()
      .then((urldoc) => {
        this.live = urldoc.data().enabled;
      });
  }
};
</script>
<style scoped>
.field {
  margin-top: -20px!important;
}
.centered_input input {
  text-align: center!important;
  
}
</style>



// WEBPACK FOOTER //
// src/components/change_url.vue